import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
// const baseURL = "http://192.168.1.240:10005";
const baseURL = "";

export default class PersonalService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public SearchUser(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/search`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // get DataByIds
  public getUpdateRoles(id: any, query): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(baseURL + `/api/auth/users/${id}/update`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
